import React from "react";
import { invoiceFields } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function InvoiceTab({ formData, onChange , errors = {} , viewOnly = false , isEdit = true }) {
    return (
        <GenericFormTab
            fields={invoiceFields}
            formData={formData}
            onChange={onChange}
            errors={errors}
            readOnly={viewOnly}
            isEdit={isEdit} 
        />
    );
}
